import React from 'react'
import styled from 'styled-components'
import { useGeckoTheme } from 'styles/GeckoTheme'

const CellContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  align-items: center;
  max-width: 12.5rem;
`

const TypeTag = styled.div`
  background-color: ${({ theme }) => theme.forecast.hoverGhostButton};
  border-radius: 0.25rem;
  padding: 0.125rem 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  color: ${({ theme }) => theme.forecast.defaultText};
  white-space: nowrap;
`

const EmptyStateTypeTag = styled(TypeTag)`
  font-style: italic;
  opacity: 0.6;
`

interface InspectionTypesCellProps {
  inspectionTypes: string[]
}

export const InspectionTypesCell: React.FC<InspectionTypesCellProps> = ({
  inspectionTypes,
}) => {
  const { theme } = useGeckoTheme()

  if (!inspectionTypes || inspectionTypes.length === 0) {
    return (
      <CellContainer>
        <EmptyStateTypeTag theme={theme}>No data layers</EmptyStateTypeTag>
      </CellContainer>
    )
  }

  const uniqueTypes = [...new Set(inspectionTypes)].sort()

  return (
    <CellContainer>
      {uniqueTypes.map((type) => (
        <TypeTag key={type} theme={theme}>
          {type}
        </TypeTag>
      ))}
    </CellContainer>
  )
}
